// components/sections/FatherInfoSection.tsx
import React from "react";
import { User, Clock, Phone, MapPin, Users } from "lucide-react";
import { InputField } from "../form/FormComponents_PediatricsRegistration";
import type { FormData } from "../../types/consultation";

interface FatherInfoSectionProps {
  formData: FormData;
  updatePediatricsInfo: (field: string, value: string | boolean) => void;
}

export const FatherInfoSection: React.FC<FatherInfoSectionProps> = ({
  formData,
  updatePediatricsInfo,
}) => {
  return (
    <div className="bg-gradient-to-br from-indigo-50 to-blue-50 p-6 rounded-2xl shadow-lg border border-indigo-100 mb-8">
      <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
        <User className="mr-2 text-indigo-600" size={24} />
        Informations du Père
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <InputField
          label="Nom du père"
          value={formData.pediatrieInfo?.nomPere || ""}
          onChange={(value) => updatePediatricsInfo("nomPere", value)}
          icon={User}
        />

        <InputField
          label="Âge"
          value={formData.pediatrieInfo?.agePere || ""}
          onChange={(value) => updatePediatricsInfo("agePere", value)}
          type="number"
          icon={Clock}
        />

        <InputField
          label="Téléphone"
          value={formData.pediatrieInfo?.telephonePere || ""}
          onChange={(value) => updatePediatricsInfo("telephonePere", value)}
          type="tel"
          icon={Phone}
        />

        <div className="lg:col-span-2">
          <InputField
            label="Adresse"
            value={formData.pediatrieInfo?.adressePere || ""}
            onChange={(value) => updatePediatricsInfo("adressePere", value)}
            icon={MapPin}
          />
        </div>

        <InputField
          label="Fonction"
          value={formData.pediatrieInfo?.fonctionPere || ""}
          onChange={(value) => updatePediatricsInfo("fonctionPere", value)}
          icon={Users}
        />
      </div>
    </div>
  );
};